/*
  workshop-cart-enforcement.js
  Defensa server-aware contra manipulación de qty>1 en items workshop.
  Escenario: un user técnico modifica /cart/update.js para forzar qty=2 en un taller.
  Sin este hook, el cart drawer mostraría 2 unidades aunque el UI lo bloquee visualmente.
  Estrategia: tras cualquier mutación del carrito, leer /cart.js, detectar items con
  properties._workshop_lock o que matcheen window.NutriWorkshopProductIds (inyectado
  desde Liquid en theme.liquid), y forzar quantity=1 via /cart/change.js si qty>1.
*/

(function () {
  'use strict';

  var LOG_PREFIX = '[WorkshopEnforcement]';
  var revertingNow = false;

  function workshopProductIds() {
    var raw = window.NutriWorkshopProductIds;
    if (Array.isArray(raw)) {
      return raw.map(String);
    }
    return [];
  }

  function isWorkshopItem(item) {
    if (!item) return false;
    var ids = workshopProductIds();
    if (ids.length > 0 && ids.indexOf(String(item.product_id)) !== -1) {
      return true;
    }
    if (item.properties && item.properties._workshop_lock === 'true') {
      return true;
    }
    var tags = item.product_tags || item.tags;
    if (Array.isArray(tags)) {
      for (var i = 0; i < tags.length; i++) {
        if (String(tags[i]).toLowerCase().indexOf('taller') !== -1) {
          return true;
        }
      }
    }
    return false;
  }

  function changeQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('cart/change.js falló: ' + response.status);
      }
      return response.json();
    });
  }

  function auditAndEnforce() {
    if (revertingNow) {
      return Promise.resolve();
    }
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('cart.js falló: ' + response.status);
      }
      return response.json();
    }).then(function (cart) {
      var items = (cart && cart.items) ? cart.items : [];
      var offenders = items.filter(function (item) {
        return isWorkshopItem(item) && item.quantity > 1;
      });
      if (offenders.length === 0) {
        return null;
      }
      console.warn(LOG_PREFIX, 'Detectados', offenders.length, 'taller(es) con qty>1. Revirtiendo a 1.');
      revertingNow = true;
      var chain = Promise.resolve();
      offenders.forEach(function (item) {
        chain = chain.then(function () {
          return changeQuantity(item.key, 1);
        });
      });
      return chain.then(function () {
        revertingNow = false;
        document.dispatchEvent(new CustomEvent('workshop-enforcement:reverted', {
          detail: { offenders: offenders.map(function (i) { return i.key; }) }
        }));
        var sectionsToRefresh = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items'];
        sectionsToRefresh.forEach(function (sectionId) {
          var sectionElement = document.getElementById(sectionId);
          if (sectionElement && typeof sectionElement.onCartUpdate === 'function') {
            sectionElement.onCartUpdate();
          }
        });
      });
    }).catch(function (error) {
      revertingNow = false;
      console.warn(LOG_PREFIX, 'Auditoría falló:', error);
    });
  }

  function bindCartEvents() {
    document.addEventListener('cart:refresh', auditAndEnforce);
    document.addEventListener('cart:updated', auditAndEnforce);
    document.addEventListener('cart-drawer:updated', auditAndEnforce);
    document.addEventListener('workshop-cart:added', auditAndEnforce);
  }

  function init() {
    console.log(LOG_PREFIX, 'init');
    bindCartEvents();
    auditAndEnforce();

    var observer = new MutationObserver(function (mutations) {
      var sawCartChange = false;
      mutations.forEach(function (mutation) {
        if (!sawCartChange && mutation.target && mutation.target.closest && (
          mutation.target.closest('cart-drawer') ||
          mutation.target.closest('cart-items') ||
          mutation.target.closest('#main-cart-items')
        )) {
          sawCartChange = true;
        }
      });
      if (sawCartChange) {
        auditAndEnforce();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
